// extracted by mini-css-extract-plugin
export default {"FullscreenButton":"FullscreenButton_FullscreenButton__N7CRK","FullscreenButton-Icon":"FullscreenButton_FullscreenButton-Icon__xs6bS"};